import React, { useContext, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import Table from "./Table";

// Tell the views reloading periodically about the rows selected, so that they
// pause while there is a selection and the rows are not replaced under the user.
export const withSelectionSignal = (Component) => {
  const WithSelectionSignal = ({ selected = [], ...rest }) => {
    const actions = useContext(ActionsContext);

    useEffect(() => {
      actions.send("selection-changed", { count: selected.length });
    }, [selected.length]);

    // Leaving the table selected would keep the reloading paused for good.
    useEffect(() => () => actions.send("selection-changed", { count: 0 }), []);

    return <Component {...rest} selected={selected} />;
  };
  WithSelectionSignal.displayName = `WithSelectionSignal(${
    Component.displayName ?? Component.name
  })`;
  return WithSelectionSignal;
};

const ActionableSelectionTable = withSelectionSignal(Table);

export default ActionableSelectionTable;
